import { getSupportedFieldConfiguration } from '../../../view-configuration';
export var mapFieldPropertyNamesToInternal = function mapFieldPropertyNamesToInternal(properties, viewType, fieldType) {
  var fieldConfiguration = getSupportedFieldConfiguration(viewType, fieldType);
  var propertyMapping = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.propertyMapping;
  if (!propertyMapping) {
    return properties;
  }

  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return Object.keys(properties).reduce(function (acc, propertyName) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    var propertyMappingValue = propertyMapping[propertyName];
    acc[propertyMappingValue !== null && propertyMappingValue !== void 0 ? propertyMappingValue : propertyName] = properties[propertyName];
    return acc;
  }, {});
};